import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import EmailIcon from '@material-ui/icons/Email';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    marginBottom: '20px'
  },
  wrapper: {

  },
  marquee: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    display: 'inline-block',
    animation: '$marquee 10s linear infinite'
  },
  '@keyframes marquee': {
    '0%': {
      transform: 'translate3d(0, 0,0)'
    },
    '100%': {
      transform: 'translate3d(-100%, 0, 0)'
    }
  }

}));

export default function VerticalLinearStepper ({ steps, updateStepsProps }) {
  const classes = useStyles();
  const { t } = useTranslation();

  React.useEffect(() => {

  }, [steps]);

  return (
    <Grid item xs={12} className={classes.root}>
      <Stepper style={{
        borderRadius: '12px'
      }} orientation='vertical'>
        { steps && steps.map((step, index) => {
          return (<Step active key={index}>
            <StepLabel>
              <Typography style={{
                color: step.isValidated || step.step.automatic ? 'black' : 'red'
              }} component='h5'> {t(`customFlow:steps:${step.step.type}`)}</Typography>
            </StepLabel>
            <StepContent>
              {!step.step.automatic &&
              <Grid container>
                <Grid style={{
                  zIndex: '1'
                }} item xs={2}>
                  <EmailIcon />
                </Grid>
                <Grid style={{ overflow: 'hidden' }} item xs={10}>
                  <Typography className={step.step.email && step.isValidated ? classes.marquee : null} disabled style={{

                    background: 'white'
                  }} label='Email' value={step.step.email || ''} variant='standard'>
                    {step.isValidated && step.step.email ? step.step.email : 'Email'}
                  </Typography>
                </Grid>

              </Grid>
              }
            </StepContent>
          </Step>)
          ;
        }
        )}
      </Stepper>
    </Grid>
  );
}
